module.exports = __webpack_public_path__ + "media/state-press-2_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-2_2000.jpg
// module id = 40
// module chunks = 0